<div class="container">
    <div class="row justify-content-center py-5">
        <div class="col-12">
            <h1>Déclaration d’accessibilité</h1>

            <p><strong>L'Agence du Numérique en Santé</strong> s’engage à rendre ses sites internet, intranet, extranet et ses
                progiciels accessibles (et ses applications mobiles et mobilier urbain numérique) conformément à l’article 47 de la
                loi n°2005-102 du 11 février 2005.</p>

            <p>Cette déclaration d’accessibilité s’applique à <strong>{{ home }}</strong>.</p>

            <h2>État de conformité</h2>

            <p><strong>ANS - Mes habilitations <a target="_blank" [href]="home" aria-label="ANS - Mes habilitations">{{ home }}</a></strong>
                est <strong>non conforme</strong> avec le référentiel général d’amélioration de l’accessibilité (RGAA).</p>

            <h2>Résultats des tests</h2>

            <p>L’audit de conformité réalisé par<strong> la Brigade d'Intervention du Numérique (BIN) de la DINUM.</strong> révèle
                que <strong>49%</strong> des critères du RGAA version 4 sont respectés.</p>

            <h2>Contenus non accessibles</h2>

            <h3>Non-conformités</h3>

            <div class="wysiwyg">
                <ul>
                    <li>Des images décoratives ne sont pas ignorées ;</li>
                    <li>L'information est parfois véhiculée uniquement par la couleur ;</li>
                    <li>Le contraste sur certains textes n'est pas respecté ;</li>
                    <li>Certains composants interactifs ont un rapport de contraste &lt; 3 ;</li>
                    <li>Certains tableaux n'ont pas de titre associé ;</li>
                    <li>Certains liens manquent de pertinence ;</li>
                    <li>Certains composant ne sont pas compatibles avec l'accessibilité et ne sont pas accessibles au clavier ;</li>
                    <li>Le titre de certaines pages n'est pas pertinent ;</li>
                    <li>Des textes en anglais n'ont pas d'indication de changement de langue ;</li>
                    <li>Des éléments HTML sont parfois utilisés à des fins de présentation ;</li>
                    <li>La hiérarchie des titres n'est pas toujours respectée ;</li>
                    <li>Des éléments ne sont pas correctement structurés en liste ;</li>
                    <li>L'information n'est pas toujours compréhensible lorsque CSS est désactivé ;</li>
                    <li>Lorsque l'uager zoom à 200%, certains contenus disparaissent ;</li>
                    <li>La prise de focus n'est pas toujours visible ;</li>
                    <li>Certains contenus sont parfois masqués au technologies d'assistances ;</li>
                    <li>Le responsive de l'application n'est pas toujours respecté ;</li>
                    <li>Certains contenus additionnels ne sont pas accessibles ;</li>
                    <li>Des champs de formulaire n'ont pas d'étiquette associée ;</li>
                    <li>Certains champs de même nature ne sont pas regroupés ;</li>
                    <li>Le format attendu des champs de saisie n'est pas indiqué ;</li>
                    <li>L'ordre de navigation n'est pas cohérent.</li>
                    <li>L'uaager n'a pas le contrôle sur la durée de session ;</li>
                    <li>Des documents en téléchargement eu format PDF ne sont pas accessibles et n'ont pas d'alternative textuelle accessible.</li>
                </ul>
            </div>

            <h2>Établissement de cette déclaration d’accessibilité</h2>

            <p>Cette déclaration a été établie le <strong>23 octobre 2024</strong>. Elle a été mise à jour le <strong>28 novembre 2024</strong>.</p>

            <h3>Technologies utilisées pour la réalisation de l’audit</h3>

            <div class="wysiwyg">
                <ul>
                    <li>HTML</li>
                    <li>CSS</li>
                    <li>Javascript</li>
                </ul>
            </div>

            <h3 class="mt-3">Environnement de test</h3>

            <p>Les vérifications de restitution de contenus ont été réalisées sur la base de la combinaison fournie par la base de référence du RGAA, avec les versions suivantes :</p>

            <div class="wysiwyg">
                <ul>
                    <li>Sur Mobile iOS avec Safari et VoiceOver</li>
                    <li>Sur Ordinateur MacOS avec Safari et VoiceOver</li>
                    <li>Sur Ordinateur Windows avec Firefox et JAWS</li>
                    <li>Sur Ordinateur Windows avec Firefox et NVDA</li>
                </ul>
            </div>

            <h3 class="mt-3">Outils pour évaluer l’accessibilité</h3>

            <div class="wysiwyg">
                <ul>
                    <li>Web Developer Toolbar</li>
                    <li>Colour Contrast Analyser</li>
                    <li>HeadingsMap</li>
                    <li>WCAG Contrast checker</li>
                    <li>Inspecteur de composants</li>
                    <li>Validateur HTML du W3C</li>
                </ul>
            </div>

            <h3 class="mt-3">Pages du site ayant fait l’objet de la vérification de conformité</h3>

            <div class="wysiwyg">
                <ul>
                    <li>Connexion <strong>{{ login }}</strong></li>
                    <li>Accueil <strong>{{ home }}</strong></li>
                    <li>Gestion des habilitations Gestionnaires RPPS+ <strong>{{ gestionGAE }}</strong></li>
                    <li>Ajout d’habilitations certificats logiciels (4 étapes) <strong>{{ habilitationCL }}</strong></li>
                    <li>Mon profil <strong>{{ profile }}</strong></li>
                    <li>Liste des contrats <strong>{{ contrat }}</strong></li>
                    <li>Détail contrat <strong>{{ contrat }}</strong></li>
                </ul>
            </div>

            <h2>Retour d’information et contact</h2>

            <p>Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter le responsable de ANS - Mes
                habilitations pour être orienté vers une alternative accessible ou obtenir le contenu sous une autre forme.</p>

            <div class="wysiwyg">
                <ul>
                    <li>Vous pouvez envoyer un mail à l'adresse suivante&nbsp;: <strong>accessibilite-ans@esante.gouv.fr</strong></li>
                </ul>
            </div>


            <h2>Voies de recours</h2>

            <p>Si vous constatez un défaut d’accessibilité vous empêchant d’accéder à un contenu ou une fonctionnalité du site, que
                vous nous le signalez et que vous ne parvenez pas à obtenir une réponse de notre part, vous êtes en droit de faire
                parvenir vos doléances ou une demande de saisine au Défenseur des droits.</p>

            <p>Plusieurs moyens sont à votre disposition :</p>

            <div class="wysiwyg">
                <ul>
                    <li><a [href]="formulaireSaisine" class="external-link" target="_blank" aria-label="Écrire un message au Défenseur des droits">Écrire un message au Défenseur des droits <span>nouvelle fenêtre</span></a></li>
                    <li><a [href]="carteDelegues" class="external-link" target="_blank" aria-label="Contacter le délégué du Défenseur des droits dans votre région">Contacter le délégué du Défenseur des droits dans votre région <span>nouvelle fenêtre</span></a></li>
                    <li>Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) à :<br><span>Défenseur des droits<br>Libre réponse 71120<br>75342 Paris CEDEX 07</span></li>
                </ul>
            </div>
        </div>
    </div>
</div>
